import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Tread from '../Tour/Tread'
import Footer from '../../Components/Footer/Footer'

const About = () => {
  return (
    <div>
      <Navbar/>
      <Tread/>
      <Footer/>
    </div>
  )
}

export default About